import { useMemo, useState } from "react";
import { categories, videos } from "../../../mocks/videos";

export default function Collections() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () =>
      active === "all"
        ? videos
        : videos.filter((v) => v.category === active),
    [active]
  );

  return (
    <section id="collections" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-700">
              <i className="ri-vidicon-line" /> 爆款视频合集盘点
            </span>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
              今日爆款合集
            </h2>
            <p className="mt-3 max-w-2xl text-foreground-600">
              按主题精选全网疯传的出圈看点，切换分类即可筛选你感兴趣的内容方向，每一个都值得刷到结尾。
            </p>
          </div>
        </div>

        {/* category filter */}
        <div className="mt-8 flex flex-wrap items-center gap-2">
          {categories.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => setActive(c.id)}
              className={
                "cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors " +
                (active === c.id
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 border border-background-300 hover:border-primary-300 hover:text-primary-600")
              }
            >
              {c.name}
            </button>
          ))}
        </div>

        {/* grid */}
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((v) => (
            <article
              key={v.id}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
            >
              <div className="relative w-full overflow-hidden">
                <img
                  src={v.cover}
                  alt={`吃瓜爆网 出圈短视频${v.categoryName}专题：${v.title}`}
                  title={`${v.title} 吃瓜爆网短视频合集`}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-primary-700 backdrop-blur-sm">
                  {v.tag}
                </span>
                <span className="absolute bottom-3 right-3 rounded-md bg-black/60 px-2 py-0.5 text-xs text-background-50">
                  {v.duration}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/85 text-primary-600">
                    <i className="ri-play-fill text-2xl" />
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-2 p-4 md:p-5">
                <h3 className="text-base font-bold leading-snug text-foreground-900 md:text-lg">
                  {v.title}
                </h3>
                <p className="line-clamp-2 text-sm text-foreground-500">
                  {v.desc}
                </p>
                <div className="mt-1 flex items-center justify-between text-sm text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" /> {v.views}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800">
                    {v.categoryName}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-foreground-500">
          当前展示 {list.length} 个精选看点 · 内容持续更新中，欢迎常回来刷一刷
        </p>
      </div>
    </section>
  );
}